<template>
  <div>
    <div>
      <div class="form-control" style="display: flow-root">
        <toggle-button
          v-model="intent.follow_up_status"
          :sync="true"
          :color="$vuetify.theme.success"
          :labels="{ checked: 'ON', unchecked: 'OFF' }"
          style="display: inline-block"
        />
        {{ $t('turn_on_follow_up') }}
        <div class="mt-2">{{ $t('send_this_message_following') }}</div>
        <v-flex xs4 class="pl-1">
          <time-picker
            v-model="intent.follow_up_within_seconds"
            class="mt-1"
            full-width
            :min-range="
              !intent.follow_up_within_seconds ||
              (intent.follow_up_within_seconds &&
                (intent.follow_up_within_seconds.HH === '' ||
                  intent.follow_up_within_seconds.HH === '00'))
                ? [[5, 55]]
                : null
            "
            :minute-interval="5"
            hide-disabled-minutes
          ></time-picker>
        </v-flex>
      </div>
      <v-layout>
        <v-flex
          v-if="showMultipleChannelFollowUp"
          class="channel"
          shrink
          style="border-right: 1px solid #eee"
        >
          <template v-for="social in conversationSocialChannelOptions">
            <div
              :key="social.value"
              class="py-1 pl-2 pr-2"
              :class="{ 'primary white--text': tab == social.value }"
              style="
                border: 1px solid #eee;
                border-width: 1px 0px 1px 1px;
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
                cursor: pointer;
              "
              @click="tab = social.value"
            >
              <span :class="social.icon"></span>
            </div>
          </template>
        </v-flex>
        <v-flex :key="timestamp" style="overflow: auto">
          <template v-if="!showMultipleChannelFollowUp">
            <intent-group
              v-model="messages"
              :show-multiple-channel="showMultipleChannelFollowUp"
              :available-bubbles="conversaionOpenType"
              :follow-up="true"
              :hide-setting="true"
              @changeSetting="changeSettingFollowUp"
            ></intent-group>
          </template>
          <template v-else>
            <template v-for="social in conversationSocialChannelOptions">
              <div v-show="social.value == tab" :key="`message-${social.value}`">
                <keep-alive>
                  <intent-group
                    :key="`${social.value}_message`"
                    :value="multiMessages[`follow_up_${social.value}_messages`]"
                    :channel="tab"
                    :show-multiple-channel="showMultipleChannelFollowUp"
                    :available-bubbles="availableIntentGroupBubbles"
                    :follow-up="true"
                    @input="
                      multiMessages = {
                        ...multiMessages,
                        [`follow_up_${social.value}_messages`]: $event
                      }
                    "
                    @changeSetting="changeSettingFollowUp"
                  ></intent-group>
                </keep-alive>
              </div>
            </template>
          </template>

          <div>
            <div class="small" style="margin-top: 10px">{{ $t('Choice') }}</div>
            <div class="mb-3"></div>

            <template v-if="!showMultipleChannelFollowUp">
              <div
                class="form-control"
                :class="{ 'has-error': errorTag['follow_up_replies'].length > 0 }"
              >
                <tags
                  v-model="follow_up_reply"
                  :tags="follow_up_replies"
                  style="margin-bottom: 5px"
                  :btn-text="$t('Add choice')"
                  @tags-changed="followUpAddReplies('follow_up_replies', $event)"
                  @before-adding-tag="checkQuickReply('follow_up_replies', $event)"
                ></tags>
              </div>
            </template>
            <template v-else>
              <template v-for="social in conversationSocialChannelOptions">
                <div
                  :key="`message-${social.value}`"
                  class="form-control"
                  :class="{
                    'has-error':
                      Object.prototype.hasOwnProperty.call(
                        errorTag,
                        `follow_up_${social.value}_replies`
                      ) && errorTag[`follow_up_${social.value}_replies`].length > 0
                  }"
                >
                  <div v-show="social.value == tab">
                    <tags
                      v-model="multiStringReplies[`follow_up_${tab}_quick_reply`]"
                      :tags="multiReplies[`follow_up_${tab}_quick_reply`]"
                      style="margin-bottom: 5px"
                      :btn-text="$t('Add choice')"
                      @tags-changed="followUpAddReplies(tab, $event)"
                      @before-adding-tag="checkQuickReply(`follow_up_${tab}_replies`, $event)"
                    ></tags>
                  </div>
                </div>
              </template>
            </template>
            <div class="form-control has-error">
              <template v-for="(error, errorKey) in errorTag">
                <span v-if="error.length > 0" :key="errorKey" class="text-error">
                  <template v-if="error.includes('overmaxlength')">{{
                    $t('Message cannot be longer than 20 alphabets')
                  }}</template>
                  <template v-else-if="error.includes('overtagmax')">{{
                    $t('Choices cannot be more than 10 items')
                  }}</template>
                  <template v-else-if="error.includes('duplicate')">{{
                    $t('Duplicate Choice')
                  }}</template>
                </span>
              </template>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="mt-3">
      <v-layout justify-center wrap>
        <v-flex shrink>
          <v-btn outline color="grey" :disabled="loading" @click="$emit('close')">{{
            $t('cancel')
          }}</v-btn>
        </v-flex>
        <v-flex shrink>
          <v-btn depressed color="primary" :loading="loading" @click="save">{{ $t('Save') }}</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'
import cloneDeep from 'lodash/cloneDeep'
import TimePicker from '@/components/elements/TimePicker.vue'
import IntentGroup from '@/components/view/intent/IntentGroup.vue'
import Tags from '@/components/elements/Tags'
import ticket3PageApi from '@/api/ticket3/page'

export default {
  components: { ToggleButton, TimePicker, IntentGroup, Tags },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tab: 'all',
      timestamp: Date.now(),
      intent: {
        follow_up_status: this.value.is_active || false,
        follow_up_within_seconds: {
          HH: Math.floor((this.value.delay_second || 0) / 60 / 60)
            .toString()
            .padStart(2, '0'),
          mm: Math.floor(((this.value.delay_second || 0) / 60) % 60)
            .toString()
            .padStart(2, '0')
        },
        follow_up_quick_reply: (this.value.quick_reply || []).join(',')
      },
      showMultipleChannelFollowUp: false,
      messages: [this.value.message || []],
      multiMessages: {},
      multiReplies: {},
      multiStringReplies: {},
      follow_up_reply: '',
      errorTag: {
        follow_up_replies: []
      },
      loading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    conversaionOpenType() {
      let output = ['text', 'image', 'button']
      switch (this.selectedBot.type) {
        case 'smom':
          output = ['text', 'image', 'button', 'line_flex']
          break
        default:
          break
      }
      return output
    },
    availableIntentGroupBubbles() {
      const types = ['text', 'image', 'button']

      if (this.tab === 'line') {
        return [...types, 'line_flex']
      }

      return types
    },
    follow_up_replies: {
      get() {
        if (
          this.intent &&
          this.intent.follow_up_quick_reply &&
          this.intent.follow_up_quick_reply !== ''
        ) {
          var quick_replies = []
          quick_replies = this.intent.follow_up_quick_reply.split(',')

          var result = []
          try {
            result = quick_replies.map((val) => {
              return { text: val }
            })
          } catch (error) {
            console.error(error)
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map((el) => {
            return el.text
          })
        } catch (error) {
          console.error(error)
        }
        this.$set(this.intent, 'follow_up_quick_reply', result.join(','))
      }
    }
  },
  methods: {
    followUpAddReplies(type, newTags) {
      if (this.conversationSocialChannelOptions.some((social) => type == social.value))
        this.multiReplies = { ...this.multiReplies, [`follow_up_${type}_replies`]: newTags }
      else this.follow_up_replies = newTags
    },
    checkQuickReply(type, obj) {
      this.errorTag[type] = []
      if (obj.tag.text == '') {
        //
      } else if (obj.tag.text.length > 20) {
        this.errorTag[type].push('overmaxlength')
        obj.error('overmaxlength:20')
      } else if (
        obj.type == 'add' &&
        this.conversationSocialChannelOptions.some(
          (social) =>
            type == `follow_up_${social.value}_replies` &&
            this.multiReplies[`follow_up_${social.value}_replies`].length >= 10
        )
      ) {
        this.errorTag[type].push('overtagmax')
        obj.error('overtagmax:10')
      } else if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorTag[type].push('duplicate')
        obj.error('duplicate')
      } else obj.addTag()
    },
    async changeSettingFollowUp(payload) {
      if (Object.hasOwnProperty.call(payload, 'showMultipleChannel')) {
        this.showMultipleChannelFollowUp = payload.showMultipleChannel

        if (this.showMultipleChannelFollowUp) this.tab = 'fb'
        else this.tab = 'all'

        if (payload.showMultipleChannel) {
          const cloneMessages = this.messages

          this.conversationSocialChannelOptions.forEach((social) => {
            if (social.value == 'fb' || social.value == 'ig') {
              this.$set(
                this.multiMessages,
                `follow_up_${social.value}_messages`,
                cloneDeep(
                  cloneMessages.map((el) => {
                    return el.filter((sel) => {
                      return !['flex', 'imagemap', 'sticker'].includes(sel.type)
                    }, [])
                  }, [])
                )
              )
            } else {
              this.$set(
                this.multiMessages,
                `follow_up_${social.value}_messages`,
                cloneDeep(cloneMessages)
              )
            }

            const quick_replies = this.intent[`follow_up_quick_reply`]
              ? this.intent[`follow_up_quick_reply`].split(',')
              : []
            this.multiReplies[`follow_up_${social.value}_quick_reply`] = quick_replies.map(
              (text) => ({ text })
            )
            this.multiStringReplies[`follow_up_${social.value}_quick_reply`] = ''
          })
        }
      }
    },
    async save() {
      try {
        this.loading = true

        await ticket3PageApi.postAdminFollowUpConfig({
          data: {
            page_id: this.selectedBot.pageid,
            ticket_v3_admin_follow_up_config: {
              is_active: this.intent.follow_up_status,
              delay_second:
                Number(this.intent.follow_up_within_seconds.HH) * 60 * 60 +
                Number(this.intent.follow_up_within_seconds.mm * 60),
              message: this.messages[0],
              quick_reply: this.intent.follow_up_quick_reply
                ? this.intent.follow_up_quick_reply.split(',')
                : []
            }
          }
        })

        this.$emit('submit')
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/AdminAutoCloseTicketManagement.vue